// extracted by mini-css-extract-plugin
export default {"formItem":"phoneInput_formItem__iZUOr"};